<template>
  <v-dialog v-model="dialog" width="300">
    <v-card flat>
      <v-card-title class="redColor pa-1 text-end">
        <v-spacer />
        <v-btn
          variant="text"
          icon
          size="small"
          color="white"
          @click="dialog = false"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-5">
        <h3>
          {{ notes }}
        </h3>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    notes: null,
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.notes = null;
      }
    },
  },
  methods: {
    open(notes) {
      this.dialog = true;
      this.notes = notes;
    },
  },
};
</script>
